import React, { useState, useEffect } from "react";
//import axios from "axios";
import API from "../api.js";
import { BASE_URL } from "../api";
import { useNavigate } from "react-router-dom";

const Verify = () => {
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔹 Load email from localStorage
  useEffect(() => {
    const savedEmail = localStorage.getItem("email");
    if (savedEmail) {
      setEmail(savedEmail);
    } else {
      navigate("/signup"); // if email not found, redirect back
    }
  }, [navigate]);

  // 🔹 Handle OTP submission
  const handleVerify = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!otp.trim()) {
      setMessage("⚠️ Please enter the OTP!");
      return;
    }

    setLoading(true);
    try {
      const res = await API.post("/users/verify-otp", {
  email: email.trim().toLowerCase(),
  otp: otp.toString().trim(),
});


      setMessage(res.data.message || "✅ Email verified successfully!");
      if (res.data.message.includes("success")) {
        setTimeout(() => navigate("/login"), 1500);
      }
    } catch (err) {
      console.error("Verification Error:", err);
      const errorMsg =
        err.response?.data?.message ||
        "❌ Verification failed! Please try again.";
      setMessage(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <form
        onSubmit={handleVerify}
        className="bg-white p-8 rounded-2xl shadow-2xl w-96 transition-transform duration-300 hover:scale-[1.02]"
      >
        <h2 className="text-3xl font-extrabold mb-6 text-center text-blue-600">
          Verify Your Email
        </h2>

        <p className="text-center text-gray-600 mb-4">
          We’ve sent an OTP to your email <b>{email}</b>
        </p>

        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          className="w-full p-3 border rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-2 rounded-lg text-white font-semibold text-lg transition ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loading ? "Verifying..." : "Verify OTP"}
        </button>

        {message && (
          <p
            className={`mt-4 text-center font-medium ${
              message.includes("✅") || message.includes("success")
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {message}
          </p>
        )}
      </form>
    </div>
  );
};

export default Verify;
